import { profileContactInfoPages } from 'platform/forms-system/src/js/patterns/prefill';
import { getContent } from 'platform/forms-system/src/js/utilities/data/profile';
import { isRelationshipToVeteran } from '../../utils/helpers';

// The 2026 form asks only for a mailing address, mobile phone and email
// (2B(8)–2B(10)). Custodians skip these pages and complete the custodian pages
// instead.
const contactInformation = profileContactInfoPages({
  content: getContent('application'),
  contactInfoPageKey: 'yourContactInformation',
  contactPath: 'your-contact-information',
  wrapperKey: 'yourContactInformation',
  addressKey: 'mailingAddress',
  mobilePhoneKey: 'mobilePhone',
  emailKey: 'email',
  included: ['mailingAddress', 'mobilePhone', 'email'],
  contactInfoRequiredKeys: ['mailingAddress', 'mobilePhone', 'email'],
  prefillPatternEnabled: true,
  showProfileAlert: true,
  // TODO(phase 2): remove the prefill check after survivors_benefits_updated_prefill is 100% in prod
  depends: formData =>
    formData?.survivorsBenefitsUpdatedPrefill === true &&
    isRelationshipToVeteran(formData) !== 'custodian',
  // Read contact info from profile.vapContactInfo (sourced from the user.json
  // vet360_contact_information mock) rather than the platform generateMockUser
  // canned data, so the contact card stays consistent with the prefilled
  // personal info.
  disableMockContactInfo: true,
});

export default contactInformation;
